function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 2.667c-.733 0-1.333.6-1.333 1.333S5.267 5.333 6 5.333c.734 0 1.334-.6 1.334-1.333S6.734 2.667 6 2.667zM4.667 8c0-.734.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333S6.734 9.333 6 9.333c-.733 0-1.333-.6-1.333-1.333zM6 13.333c.734 0 1.334-.6 1.334-1.333s-.6-1.334-1.334-1.334c-.733 0-1.333.6-1.333 1.334 0 .733.6 1.333 1.333 1.333zM11.334 4c0 .733-.6 1.333-1.334 1.333-.733 0-1.333-.6-1.333-1.333s.6-1.333 1.333-1.333c.734 0 1.334.6 1.334 1.333zM10 6.667c-.733 0-1.333.6-1.333 1.333s.6 1.333 1.333 1.333c.734 0 1.334-.6 1.334-1.333 0-.734-.6-1.333-1.334-1.333zM8.667 12c0-.733.6-1.334 1.333-1.334.734 0 1.334.6 1.334 1.334 0 .733-.6 1.333-1.334 1.333-.733 0-1.333-.6-1.333-1.333z",
  clipRule: "evenodd"
});

var SvgIcActionDrag = function SvgIcActionDrag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcActionDrag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_action_drag.0d7e833f.svg";
export { ForwardRef as ReactComponent };